export default __webpack_public_path__ + "static/media/taj.18cd39cd.svg";